// 日付関連の変数（変更なし）
const today = new Date();
const year = today.getFullYear();
const month = today.getMonth() + 1;
const date = today.getDate();
const day = today.getDay();
const hour = today.getHours();
const todayDate = `${year}-${month}-${date}`;

// 祝日計算関数（変更なし）
const thisYearFirstDay = new Date(year, 1 - 1, 1);
const monHoliday = function(monthNum, n) {
  let BOMday = new Date(year, monthNum - 1, 1).getDay();
  let adjustDate = n * 7 + 2;
  if (BOMday === 0 || BOMday === 1) {
    adjustDate += -7 - BOMday;
  } else {
    adjustDate += -BOMday;
  }
  return `${year}-${String(monthNum).padStart(2, '0')}-${String(adjustDate).padStart(2, '0')}`;
};

// --- ここから振替休日のロジックを追加 ---

// 祝日リスト（振替休日計算用）
// このリストは、振替休日計算の元となる固定の祝日です。
// YYYY-MM-DD形式にしてください。
const fixedNationalHolidays = [
  `${year}-01-01`, // 元日
  monHoliday(01, 2), // 成人の日
  `${year}-02-11`, // 建国記念の日
  `${year}-02-23`, // 天皇誕生日
  `${year}-04-29`, // 昭和の日
  `${year}-05-03`, // 憲法記念日
  `${year}-05-04`, // みどりの日
  `${year}-05-05`, // こどもの日
  monHoliday(07, 3), // 海の日
  `${year}-08-11`, // 山の日
  monHoliday(09, 3), // 敬老の日
  monHoliday(10, 2), // スポーツの日
  `${year}-11-3`, // 文化の日
  `${year}-11-23`, // 勤労感謝の日
];

// 振替休日を計算する関数
function calculateSubstituteHolidays(holidaysArray, currentYear) {
  const substituteHolidays = new Set(); // 重複を防ぐためにSetを使用

  holidaysArray.forEach(holidayStr => {
    const holidayDate = new Date(holidayStr);

    // 祝日が今年または来年の日付であることを確認
    // （古い日付や遠い将来の日付を除外するため）
    if (holidayDate.getFullYear() !== currentYear && holidayDate.getFullYear() !== currentYear + 1) {
        return;
    }

    // 祝日が日曜日（getDay() === 0）の場合
    if (holidayDate.getDay() === 0) {
      let nextDay = new Date(holidayDate);
      nextDay.setDate(holidayDate.getDate() + 1); // 翌日

      // 翌日が次の祝日でない限り、振替休日として追加
      // 日本の祝日法では、振替休日は「その日以後において、その日（日曜日を除く）に最も近い国民の祝日でない日」
      // とされているため、連続する祝日を考慮する必要があります。
      // シンプルな実装として、次の日が日曜日でなく、かつ既に祝日リストにないことを確認します。
      while (nextDay.getDay() === 0 || 
             fixedNationalHolidays.includes(`${nextDay.getFullYear()}-${String(nextDay.getMonth() + 1).padStart(2, '0')}-${String(nextDay.getDate()).padStart(2, '0')}`) || 
             substituteHolidays.has(`${nextDay.getFullYear()}-${String(nextDay.getMonth() + 1).padStart(2, '0')}-${String(nextDay.getDate()).padStart(2, '0')}`)) 
      {
        nextDay.setDate(nextDay.getDate() + 1);
      }
      substituteHolidays.add(`${nextDay.getFullYear()}-${String(nextDay.getMonth() + 1).padStart(2, '0')}-${String(nextDay.getDate()).padStart(2, '0')}`);
    }
  });
  return Array.from(substituteHolidays);
}

// 振替休日を計算
const calculatedSubstituteHolidays = calculateSubstituteHolidays(fixedNationalHolidays, year);

// 全ての固定休業日（元の set_holidays の内容を再構築）
// calculateSubstituteHolidays の input とは別に、最終的なセットを作成します
// 年末年始やお盆休みなどは別途メタフィールドで設定してください
const set_holidays = [
  ...fixedNationalHolidays, // 元の固定祝日
  ...calculatedSubstituteHolidays, // 計算された振替休日
];

// 他のスクリプトでこれらの変数や関数を使えるようにエクスポート
window.ShopifySetHolidays = {
  today,
  year,
  month,
  date,
  day,
  hour,
  todayDate,
  monHoliday,
  set_holidays // 振替休日が含まれた最終的な休業日リスト
};